module.exports = __webpack_public_path__ + "img/yezi0.66a33562.png";